module.exports = __webpack_public_path__ + "img/university_thumbnail-600x450.10f40880.jpg";